import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const frontendUrl = window.location.href;

const Formservice = {
  async get_lot_list(id_type) {
    try {
      const result = await axios.get(`${apiUrl}/lot_choix_list`, {
        params: { id_type: id_type/* , lien: frontendUrl  */},
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async liste() {
    try {
      const result = await axios.post(`${apiUrl}/index`, { lien: frontendUrl });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async districtListe() {
    try {
      const result = await axios.get(`${apiUrl}/district_list`, {
        lien: frontendUrl,
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async recupererDiplome(id_min_diplome) {
    try {
      const result = await axios.get(`${apiUrl}/recuperation_diplome`, {
        params: { id_min_diplome },
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async directionListe() {
    try {
      const result = await axios.get(`${apiUrl}/directions_fid_list`, {
        lien: frontendUrl,
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async domaine(id_type) {
    try {
      const result = await axios.get(`${apiUrl}/domaine`, {
        params: { id_type: id_type || null },
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async domaine_ci(filtre) {
    try {
      const result = await axios.get(`${apiUrl}/domaine_ci`, {
        params: { filtre },
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async details(ref) {
    try {
      const result = await axios.get(`${apiUrl}/details/` + ref);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async sousdomaine(id) {
    try {
      const result = await axios.get(`${apiUrl}/sousdomaine/` + id);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async saveacceuil(formData) {
    try {
      const result = await axios.post(`${apiUrl}/acceuil`, {
        formData: formData,
        lien: frontendUrl,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async saveidentity(formData) {
    try {
      const result = await axios.post(`${apiUrl}/identity`, formData);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async competence(formData, ref) {
    try {
      const result = await axios.post(`${apiUrl}/competence/` + ref, formData);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateidentity(formData) {
    try {
      const result = await axios.put(`${apiUrl}/identity`, formData);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async updateetude(formData, ref, id) {
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });
    formDataToSend.append("ref", ref);
    try {
      const response = await axios.post(
        `${apiUrl}/updateetude/` + id,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response) {
        return response.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateexperience(formData, ref, reference, id) {
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key == "domaine") {
        formDataToSend.append(key, formData[key].name);
      } else if (key == "sous_domaine") {
        formDataToSend.append(key, formData[key].name);
      } else {
        formDataToSend.append(key, formData[key]);
      }
    });
    formDataToSend.append("ref", ref);
    Object.keys(reference).forEach((key) => {
      formDataToSend.append(key, reference[key]);
    });
    try {
      const response = await axios.post(
        `${apiUrl}/updateexperience/` + id,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        return response.data;
      }
    } catch (error) {}
  },

  async deletecompetence(id, ref) {
    try {
      const result = await axios.post(
        `${apiUrl}/deletecompetence/` + id + `/` + ref,
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteetude(id, ref) {
    try {
      const result = await axios.get(`${apiUrl}/etudedelete/` + id + `/` + ref);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async saveetude(formData, ref) {
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });
    formDataToSend.append("ref", ref);
    try {
      const response = await axios.post(`${apiUrl}/etude`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response) {
        return response.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteexperience(id, ref) {
    try {
      const result = await axios.get(
        `${apiUrl}/experiencedelete/` + id + `/` + ref,
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async saveexperience(formData, ref, reference) {
    const formDataToSend = new FormData();
    console.log("form data:", formData);

    Object.keys(formData).forEach((key) => {
      if (key == "domaine") {
        formDataToSend.append(key, formData[key].name);
      } else if (key == "sous_domaine") {
        formDataToSend.append(key, formData[key].name);
      } else {
        formDataToSend.append(key, formData[key]);
      }
    });
    formDataToSend.append("ref", ref);
    Object.keys(reference).forEach((key) => {
      formDataToSend.append(key, reference[key]);
    });
    try {
      const response = await axios.post(
        `${apiUrl}/experience`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        return response.data;
      }
    } catch (error) {}
  },
  async saveautrecompetence(rows, informatique, languages, ref) {
    try {
      const formData = new FormData();
      formData.append("rows", JSON.stringify(rows));
      formData.append("informatique", JSON.stringify(informatique));
      formData.append("languages", JSON.stringify(languages));
      formData.append("ref", ref);

      const response = await axios.post(`${apiUrl}/autrecompetence`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response) {
        return response.data;
      }
    } catch (error) {}
  },
  async savefile(formData, ref) {
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });
    formDataToSend.append("ref", ref);
    try {
      const response = await axios.post(`${apiUrl}/file`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response) {
        return response.data;
      }
    } catch (error) {}
  },
  async soumettre(formData, ref) {
    try {
      const result = await axios.post(`${apiUrl}/finaly/` + ref, formData);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async identifiant(ref) {
    try {
      const result = await axios.get(`${apiUrl}/identif/` + ref);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async getcompetence(ref) {
    try {
      const result = await axios.get(`${apiUrl}/comptence1/` + ref);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async getformation(ref) {
    try {
      const result = await axios.get(`${apiUrl}/formation1/` + ref);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async description(ref, desc) {
    try {
      const result = await axios.post(`${apiUrl}/adddesc/` + ref, desc);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async saveChoixLocalisation(data) {
    try {
      const result = await axios.post(`${apiUrl}/insertDistrict/`, data);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async editPretentionSalariale(data) {
    try {
      const result = await axios.post(`${apiUrl}/update_pretention/`, data);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async editDispoAndTypeStage(data) {
    try {
      const result = await axios.post(
        `${apiUrl}/update_disponibilite_type_stage/`,
        data,
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
};

export default Formservice;
